import i18n from '@/i18n'
import contacts from '@/api/apiSferest/services/contacts'

/**
 * Set Contact
 * @param {Object} payload - Contact Object element to set.
 */
export const set = ({ commit, dispatch, state, getters }, payload) => {
  return new Promise((resolve, reject) => {
    commit('SET_ID', payload.id)
    commit('SET_TYPE', payload.type)
    commit('SET_RESIDENCE', payload.residence)
    commit('SET_TRADENAME', payload.tradeName)
    commit('SET_NAME', payload.name)
    commit('SET_LASTNAME', payload.lastName)
    commit('SET_DOCUMENT', payload.document)
    commit('SET_SOURCE', payload.source)
    commit('SET_ADDITIONAL_INFO', payload.additionalInfo)
    if (payload.contractReference) commit('SET_CONTRACT_REFERENCE', payload.contractReference)
    Promise.all([
      ...['address', 'contactMedium', 'accountingOffice', 'managerBody', 'processingUnit', 'proponentBody', 'FACeB2B']
        .map(k => {
          return dispatch(`${k}/set`, payload[k])
        })
    ]).then(() => {
      commit('SET_HASCONTACTMEDIUM', getters['contactMedium/hasData'])
      commit('SET_HASCONTRACTREFERENCE', !!state.contractReference)
      setDirType(commit, getters)
      resolve(state)
    })
  })
}

/**
 * Get Contact details
 * @param {Object} payload - Contact basic information (id or source).
 */
export const get = ({ commit, dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    if (!payload || !payload.id || !payload.source) {
      reject(new Error('Wrong selection'))
      return
    }
    let {
      id,
      source,
      thirdpartyContact
    } = payload
    contacts.get(source, id, thirdpartyContact).then((res) => {
      let contact = res.data
      contact.source = source
      dispatch('set', contact).then(contact => resolve(contact))
    })
  })
}

export const create = ({ commit, getters, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    cleanDir(state.dirType, dispatch)
    const contact = getters.apificate
    if (contact.id) delete contact.id
    setDirType(commit, getters)
    if(!validateContactDir3(contact, getters['dirType'])) {
      const msg = i18n.t('invoices.save.errors.dir3Info')
      dispatch('errors/addValidationError', { msg }, { root: true })
      return
    }
    contacts.create(contact).then((res) => {
      resolve(contact)
    })
  })
}

/**
 * Update Contact information
 * @param {Object} payload - Basic Contact information (id or source).
 */
export const update = ({ commit, getters, dispatch, state }, payload) => {
  return new Promise((resolve, reject) => {
    if (!payload || !payload.id || !payload.source) reject(new Error('Wrong update info'))
    let {
      id,
      source
    } = payload
    if (source === 'promoter') reject(new Error('Los contactos de la promotora no pueden ser modificados'))
    cleanDir(state.dirType, dispatch)
    const contact = getters.apificate
    setDirType(commit, getters)
    if(!validateContactDir3(contact, getters['dirType'])) {
      const msg = i18n.t('invoices.save.errors.dir3Info')
      dispatch('errors/addValidationError', { msg }, { root: true })
      return
    }
    contacts.update(source, id, contact).then((res) => {
      resolve(contact)
    })
  })
}

const setDirType = (commit, getters) => {
  if (getters['FACeB2B/apificate']) {
    commit('SET_DIRTYPE', 'faceb2b')
  } else if (getters['accountingOffice/apificate'] ||
      getters['managerBody/apificate'] ||
      getters['processingUnit/apificate'] ||
      getters['proponentBody/apificate']) {
    commit('SET_DIRTYPE', 'face')
  } else {
    commit('SET_DIRTYPE', 'noFace')
  }
}

const validateContactDir3 = (contact, dirType) => {
  if (dirType === 'face') {
    const accountingOffice = contact.accountingOffice
    const managerBody = contact.managerBody
    const processingUnit = contact.processingUnit
    return (accountingOffice && managerBody && processingUnit &&
              accountingOffice.code && managerBody.code && processingUnit.code)
  }
  return true
}

/**
 * Cleans contact DIR info
 * @param {*} dirType Type of DIR
 * @param {*} dispatch  Store dispatch method
 */
function cleanDir(dirType, dispatch) {
  if (dirType === 'faceb2b') {
    // dispatch('accountingOffice/empty')
    // dispatch('managerBody/empty')
    // dispatch('processingUnit/empty')
    // dispatch('proponentBody/empty')
  } else if (dirType === 'face') {
    dispatch('FACeB2B/empty')
  } else if (dirType === 'noFace') {
    dispatch('accountingOffice/empty')
    dispatch('managerBody/empty')
    dispatch('processingUnit/empty')
    dispatch('proponentBody/empty')
    dispatch('FACeB2B/empty')
  }
}

export const empty = ({ commit, dispatch }) => {
  return new Promise((resolve) => {
    commit('SET_TYPE', 'NP')
    commit('SET_RESIDENCE', 'R')
    commit('SET_TRADENAME', undefined)
    commit('SET_NAME', undefined)
    commit('SET_LASTNAME', undefined)
    commit('SET_DOCUMENT', undefined)
    commit('SET_SOURCE', undefined)
    commit('SET_ADDITIONAL_INFO', undefined)
    commit('SET_ADDITIONAL_INFOSTORE', undefined)
    /* address */
    commit('address/SET_STREET', undefined)
    commit('address/SET_POSTALCODE', undefined)
    commit('address/SET_TOWN', undefined)
    commit('address/SET_CITY', undefined)
    commit('address/SET_COUNTRY', 'ES')
    /* contactMedium */
    commit('contactMedium/SET_NAME', undefined)
    commit('contactMedium/SET_TELEPHONE', undefined)
    commit('contactMedium/SET_EMAIL', undefined)
    commit('contactMedium/SET_FAX', undefined)
    commit('contactMedium/SET_DEPARTMENT', undefined)
    commit('contactMedium/SET_DEPARTMENTCODE', undefined)
    /* accountingOffice */
    commit('accountingOffice/SET_CODE', undefined)
    commit('accountingOffice/SET_DESCRIPTION', undefined)
    commit('accountingOffice/address/SET_STREET', undefined)
    commit('accountingOffice/address/SET_POSTALCODE', undefined)
    commit('accountingOffice/address/SET_TOWN', undefined)
    commit('accountingOffice/address/SET_CITY', undefined)
    commit('accountingOffice/address/SET_COUNTRY', 'ES')
    commit('accountingOffice/SET_NAME', undefined)
    commit('accountingOffice/SET_FIRSTNAME', undefined)
    commit('accountingOffice/SET_LASTNAME', undefined)
    /* managerBody */
    commit('managerBody/SET_CODE', undefined)
    commit('managerBody/SET_DESCRIPTION', undefined)
    commit('managerBody/address/SET_STREET', undefined)
    commit('managerBody/address/SET_POSTALCODE', undefined)
    commit('managerBody/address/SET_TOWN', undefined)
    commit('managerBody/address/SET_CITY', undefined)
    commit('managerBody/address/SET_COUNTRY', 'ES')
    commit('managerBody/SET_NAME', undefined)
    commit('managerBody/SET_FIRSTNAME', undefined)
    commit('managerBody/SET_LASTNAME', undefined)
    /* processingUnit */
    commit('processingUnit/SET_CODE', undefined)
    commit('processingUnit/SET_DESCRIPTION', undefined)
    commit('processingUnit/address/SET_STREET', undefined)
    commit('processingUnit/address/SET_POSTALCODE', undefined)
    commit('processingUnit/address/SET_TOWN', undefined)
    commit('processingUnit/address/SET_CITY', undefined)
    commit('processingUnit/address/SET_COUNTRY', 'ES')
    commit('processingUnit/SET_NAME', undefined)
    commit('processingUnit/SET_FIRSTNAME', undefined)
    commit('processingUnit/SET_LASTNAME', undefined)
    /* proponentBody */
    commit('proponentBody/SET_CODE', undefined)
    commit('proponentBody/SET_DESCRIPTION', undefined)
    commit('proponentBody/address/SET_STREET', undefined)
    commit('proponentBody/address/SET_POSTALCODE', undefined)
    commit('proponentBody/address/SET_TOWN', undefined)
    commit('proponentBody/address/SET_CITY', undefined)
    commit('proponentBody/address/SET_COUNTRY', 'ES')
    commit('proponentBody/SET_NAME', undefined)
    commit('proponentBody/SET_FIRSTNAME', undefined)
    commit('proponentBody/SET_LASTNAME', undefined)
    /* others */
    commit('SET_CONTRACT_REFERENCE', undefined)
    commit('SET_HASCONTRACTREFERENCE', false)
    commit('SET_HASCONTACTMEDIUM', false)
    commit('SET_ISCONTRACTREFERENCEMANDATORY', false)
    // FACeB2B
    dispatch('FACeB2B/empty')
    resolve()
  })
}

export const loading = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', false)
    resolve(false)
  })
}

export const loaded = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', true)
    resolve(true)
  })
}
